import React from 'react'

export default () => (
  <div>
    <h1>About Us</h1>
    <p>Hello Medium!</p>
  </div>
)



// WEBPACK FOOTER //
// ./src/containers/About/About.js